// extracted by mini-css-extract-plugin
export default {"link":"_7i4M","menuName":"bakE2","arrow":"A52IA"};